import { FormErrorMessage } from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';

type Props = { title: string };

export default function FormErrorMessageWithSpacing({ title }: Props) {
  return (
    <AnimatePresence>
      {title && (
        <motion.div
          initial={{ opacity: 0, height: 0, marginTop: 0 }}
          animate={{ opacity: 1, height: 'auto', marginTop: 4 }}
          exit={{ opacity: 0, height: 0, marginTop: 0 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
          style={{ overflow: 'hidden' }}
        >
          <FormErrorMessage mt={0}>{title}</FormErrorMessage>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
